/* disabled some linting as was causing issues with implementing interface correctly */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { AppDateAdapter, APP_DATE_FORMATS } from './date-picker.adapter';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true,
        },
        {
            provide: DateAdapter,
            useClass: AppDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS,
        },
    ],
    imports: [
        MatDatepicker,
        MatInput,
        FormsModule,
        MatDatepickerInput,
        ReactiveFormsModule,
    ],
})
export class DatePickerComponent implements ControlValueAccessor, OnDestroy {
  public dateControl = new UntypedFormControl('');

  @Input() placeholder = 'Enter Date...';

  @Input() dateError = false;

  private onChangeSubscriptions: Subscription | undefined;

  public onTouched: () => void = () => {};

  writeValue(obj: any): void {
    this.dateControl.patchValue(obj, { onlySelf: true, emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChangeSubscriptions = this.dateControl.valueChanges
      .pipe()
      .subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.dateControl.disable() : this.dateControl.enable();
  }

  ngOnDestroy(): void {
    this.onChangeSubscriptions?.unsubscribe();
  }
}
